
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {closeToast, cancelToastClosing, closeToastWithTimeout} from 'redux/modules/ui/toaster/actions'
import Toast from 'components/Toast'
import {TransitionMotion, spring, presets} from 'react-motion'

const TOAST_MAX_HEIGHT = 300
const TOAST_INITIAL_OFFSET = 80

export class Toaster extends React.Component {
  static propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({
      message: PropTypes.string,
      options: PropTypes.object,
      id: PropTypes.string.isRequired
    })),
    closeToast: PropTypes.func,
    cancelToastClosing: PropTypes.func,
    closeToastWithTimeout: PropTypes.func
  }

  static defaultProps = {
    list: []
  }

  render() {
    const {
      list,
      closeToast,
      cancelToastClosing,
      closeToastWithTimeout
    } = this.props

    return (
      <TransitionMotion
        willLeave={this.willLeave}
        willEnter={this.willEnter}
        styles={list.map(data => ({
          key: String(data.id),
          style: {
            y: spring(0, presets.stiff),
            height: spring(TOAST_MAX_HEIGHT),
            opacity: spring(1, presets.stiff)
          },
          data
        }))}
      >
        {styles =>
          <div className='toaster'>
            {styles.map(({style, data, key}, index) =>
              <div
                style={{
                  transform: `translateY(${style.y}px)`,
                  opacity: style.opacity,
                  maxHeight: style.height
                }}
                key={key || index}
              >
                <Toast
                  {...data.options}
                  onClose={() => closeToast(key)}
                  onMouseOver={() => cancelToastClosing(key)}
                  onMouseOut={() => closeToastWithTimeout(key)}
                >
                  {data.message}
                </Toast>
              </div>
            )}
          </div>
        }
      </TransitionMotion>
    )
  }

  willEnter() {
    return {
      y: -TOAST_INITIAL_OFFSET,
      height: TOAST_MAX_HEIGHT,
      opacity: 0
    }
  }

  willLeave() {
    return {
      y: spring(-TOAST_INITIAL_OFFSET, presets.stiff),
      height: spring(0),
      opacity: spring(0, presets.stiff)
    }
  }
}

export default connect(state => {
  return {
    list: state.ui.toaster.list || []
  }
}, {
  closeToast,
  cancelToastClosing,
  closeToastWithTimeout
})(Toaster)



// WEBPACK FOOTER //
// ./client/containers/Toaster/index.js